import React, { useEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { DOM_ID } from '@UILayer/UILayer.types';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

// CSS
import styles from '@UILayer/UILayer.scss';
import { Button } from '@UILayer/Inputs/Button';

//PANELS & VIEWS

const PreloaderInfoActions: React.FC<{ loaderState: string | undefined }> = ({ loaderState }) => {
    const { t } = useTranslation();

    function continueAction() {
        EventsCenter.emit(EGameEvents.PRELOADER_INTRO_MOVIE_SKIP);
    }
    return (
        <>
            {loaderState === 'COMPLETE' && (
                <Button id={DOM_ID.BUTTON_CONTINUE} description={t('WCA_CONTINUE')} className={cn(styles.prealoder_button_rect)} onChange={continueAction}>
                    {t('CONTINUE')}
                </Button>
            )}
        </>
    );
};

export default PreloaderInfoActions;
